var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import * as React from 'react';
import axios from 'axios';
import 'slick-carousel/slick/slick.css';
import Select from 'react-select';
import * as classNames from 'classnames';
import { useMutation } from 'react-apollo';
import 'slick-carousel/slick/slick-theme.css';
import { withStyles } from '@material-ui/core/styles';
import * as MobileDetect from 'mobile-detect/mobile-detect';
import { Dialog, Icon, ListItemText, MenuItem } from '@material-ui/core';
import store from 'src/store';
import { mainApi } from 'src/config';
import { getInitials } from 'src/utils/common';
import Spinner from 'src/components/reusable/Spinner';
import { countries } from 'src/constants/countries';
import { checkIfDevelopmentStage } from 'src/utils/common';
import styles from './UserInitialConfigurationDialog.style';
import { getTranslation, getLanguages } from 'src/translation';
import { setUserProfile, setUserConfigurationStatus } from 'src/auth/store/actions/user.actions';
import { getUserPermissions } from 'src/auth/cognito/organizationApi';
import { userCommandGQL, userCommandVariables } from '../../../gql/userCommand';
import { TRAININGTUBE_SUPPORTED_LANGUAGES } from 'src/utils/constants';
var FIRST_PAGE = 1;
var SECOND_PAGE = 2;
var THIRD_PAGE = 3;
var S3_PREFIX = 'https://static-polly-audio.s3.eu-west-1.amazonaws.com/welcome-screenshots/';
var orgToNotShowTheDialog = ['orstedcom', 'semcomaritime'];
var reactSelectStyles = {
    control: function (provided, state) { return (__assign(__assign({}, provided), { minHeight: '16px', height: '32px', border: 0, boxShadow: 'none' })); },
    valueContainer: function (provided, state) { return (__assign(__assign({}, provided), { height: '32px', padding: '0 6px' })); },
    indicatorSeparator: function (state) { return ({
        display: 'none',
    }); },
    indicatorsContainer: function (provided, state) { return (__assign(__assign({}, provided), { height: '32px', marginTop: -2 })); },
    menu: function (provided) { return (__assign(__assign({}, provided), { zIndex: 9999 })); },
    menuPortal: function (base) { return (__assign(__assign({}, base), { zIndex: 9999 })); },
};
var UserInitialConfigurationDialog = function (props) {
    var open = props.open, orgId = props.orgId, classes = props.classes, profile = props.profile, tubeColor = props.tubeColor, userEmail = props.userEmail, userLanguage = props.userLanguage, saveUserProfile = props.saveUserProfile, organizationLanguages = props.organizationLanguages;
    var _a = React.useState(false), isSaving = _a[0], setSavingStatus = _a[1];
    var _b = React.useState(FIRST_PAGE), currentPage = _b[0], setCurrentPage = _b[1];
    var _c = React.useState(userLanguage || 'en-us'), selectedLanguage = _c[0], setSelectedLanguage = _c[1];
    var _d = React.useState(false), showAllLanguages = _d[0], setShowAllLangsStatus = _d[1];
    var _e = React.useState(profile === null || profile === void 0 ? void 0 : profile.firstName), firstName = _e[0], setFirstName = _e[1];
    var _f = React.useState(profile === null || profile === void 0 ? void 0 : profile.lastName), lastName = _f[0], setLastName = _f[1];
    var _g = React.useState(profile === null || profile === void 0 ? void 0 : profile.profilePic), profilePic = _g[0], setProfilePicture = _g[1];
    var _h = React.useState(null), selectedFile = _h[0], setSelectedFile = _h[1];
    var _j = React.useState(profile === null || profile === void 0 ? void 0 : profile.phoneNumber), phoneNumber = _j[0], setPhoneNumber = _j[1];
    var _k = React.useState(profile === null || profile === void 0 ? void 0 : profile.country), country = _k[0], setCountry = _k[1];
    var _l = React.useState(profile === null || profile === void 0 ? void 0 : profile.jobTitle), jobTitle = _l[0], setJobTitle = _l[1];
    var translate = getTranslation(selectedLanguage);
    // React.useEffect(() => {
    //   if (orgToNotShowTheDialog.includes(orgId)) {
    //     return
    //   }
    //   try {
    //     const fetchUsersLocation = () => {
    //       if (window.navigator.geolocation) {
    //         const successfulLookup = async position => {
    //           const { latitude, longitude } = position.coords
    //           const result = await fetch(
    //             `https://api.opencagedata.com/geocode/v1/json?q=${latitude}+${longitude}&key=fa07a4cb2b4a4ab9b11b67dfce8bf973`
    //           )
    //           const data = await result.json()
    //           const country = data.results[0].components.country
    //           setCountry(country)
    //         }
    //         window.navigator.geolocation.getCurrentPosition(position => successfulLookup(position) as any, console.log)
    //       }
    //     }
    //     if (!profile?.country) {
    //       fetchUsersLocation()
    //     }
    //   } catch (e) {
    //     console.log('error when geolocating')
    //   }
    // }, [])
    var updateUserStatus = useMutation(userCommandGQL, userCommandVariables({
        type: 'completeUserConfigurationStatus',
        payload: { isConfigurationCompleted: true },
    }))[0];
    var updateUserPreferredLanguage = useMutation(userCommandGQL, userCommandVariables({
        type: 'updatePreferredLanguage',
        payload: { language: selectedLanguage },
    }))[0];
    var onSaveProfile = function (isUserDetailsPage) { return __awaiter(void 0, void 0, void 0, function () {
        var data, isDevStage, mainApiUrl, pathUrl, apiRes, data;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!isUserDetailsPage) return [3 /*break*/, 3];
                    // If nothing has changed do not do anything
                    if (firstName === profile.firstName &&
                        lastName === profile.lastName &&
                        jobTitle === profile.jobTitle &&
                        country === profile.country &&
                        phoneNumber === profile.phoneNumber) {
                        return [2 /*return*/];
                    }
                    return [4 /*yield*/, saveUserProfile({
                            firstName: firstName,
                            lastName: lastName,
                            jobTitle: jobTitle,
                            country: country,
                            phoneNumber: phoneNumber,
                        })
                        // Refetch users data
                    ];
                case 1:
                    _a.sent();
                    return [4 /*yield*/, getUserPermissions()
                        // save to redux
                    ];
                case 2:
                    data = _a.sent();
                    // save to redux
                    setUserProfile(data.userData)(store.dispatch);
                    return [2 /*return*/];
                case 3:
                    isDevStage = checkIfDevelopmentStage();
                    mainApiUrl = mainApi(isDevStage);
                    pathUrl = void 0;
                    if (!selectedFile) return [3 /*break*/, 8];
                    return [4 /*yield*/, axios({
                            method: 'post',
                            url: mainApiUrl.command + "/getGenericS3UploadSignedUrl",
                            headers: { Authorization: 'Bearer ' + localStorage.getItem('token') },
                            data: {
                                fileExt: selectedFile.name.split('.').pop(),
                            },
                        })];
                case 4:
                    apiRes = _a.sent();
                    pathUrl = apiRes.data;
                    // Upload to s3
                    return [4 /*yield*/, axios({
                            method: 'put',
                            url: pathUrl.signedUrl,
                            headers: {
                                'content-type': selectedFile.type,
                            },
                            data: selectedFile,
                        })];
                case 5:
                    // Upload to s3
                    _a.sent();
                    return [4 /*yield*/, saveUserProfile(__assign(__assign({}, (!profilePic && { profilePic: '' })), (pathUrl && { profilePic: pathUrl.s3Path })))
                        // Refetch users data
                    ];
                case 6:
                    _a.sent();
                    return [4 /*yield*/, getUserPermissions()
                        // save to redux
                    ];
                case 7:
                    data = _a.sent();
                    // save to redux
                    setUserProfile(data.userData)(store.dispatch);
                    return [2 /*return*/];
                case 8: return [2 /*return*/];
            }
        });
    }); };
    var onClose = function () { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            updateUserStatus();
            // save to redux
            setUserConfigurationStatus(true)(store.dispatch);
            props.onClose();
            return [2 /*return*/];
        });
    }); };
    var md = new MobileDetect(window.navigator.userAgent);
    var isMobile = md.mobile();
    var languagesToShow = (showAllLanguages || !organizationLanguages.length
        ? getLanguages()
        : organizationLanguages).filter(function (lang) { return lang !== userLanguage && TRAININGTUBE_SUPPORTED_LANGUAGES.includes(lang); });
    var handleChange = function (selectedCountry) {
        setCountry(selectedCountry.value);
    };
    var renderLanguageSelectPage = function () {
        return (React.createElement("div", { style: { margin: '15px 25px 0px 25px' } },
            React.createElement("h1", null, translate('select-your-languge')),
            React.createElement("div", { className: "fs--15 mt--5 mb--25" }, translate('select-lang-reason')),
            React.createElement("div", { className: "ds-flex" },
                React.createElement("div", null,
                    React.createElement("div", { className: classes.columnPreview }, translate('language-select')),
                    React.createElement("div", { style: { maxHeight: 435, width: 265 }, className: classes.langSelect },
                        React.createElement(MenuItem, { style: selectedLanguage === userLanguage ? { background: tubeColor, color: 'white', fontWeight: 500 } : {}, id: "lang-" + userLanguage, name: userLanguage, className: classes.langItem, key: userLanguage, onClick: function () { return setSelectedLanguage(userLanguage); } },
                            React.createElement(ListItemText, { disableTypography: true, className: "pl-0", primary: translate(userLanguage) }),
                            selectedLanguage === userLanguage && (React.createElement(Icon, { style: { color: 'white', marginLeft: 15 } }, "check_circle_outline"))),
                        languagesToShow
                            .sort(function (a, b) { return translate(a).localeCompare(translate(b)); })
                            .map(function (lang) { return (React.createElement(MenuItem, { id: "lang-" + lang, name: lang, style: selectedLanguage === lang ? { background: tubeColor, color: 'white', fontWeight: 500 } : {}, className: classes.langItem, key: lang, onClick: function () { return setSelectedLanguage(lang); } },
                            React.createElement(ListItemText, { disableTypography: true, className: "pl-0", primary: translate(lang) }),
                            selectedLanguage === lang && (React.createElement(Icon, { style: { color: 'white', marginLeft: 15 } }, "check_circle_outline")))); }),
                        !!organizationLanguages.length && (React.createElement(MenuItem, { className: classes.langItem, onClick: function () { return setShowAllLangsStatus(!showAllLanguages); } },
                            React.createElement("div", { className: "ds-flex" },
                                React.createElement(Icon, { style: { color: tubeColor } }, !showAllLanguages ? 'expand_more' : 'expand_less'),
                                React.createElement(ListItemText, { disableTypography: true, className: "pl-0", primary: translate(showAllLanguages ? 'see-less' : 'see-all') })))))),
                React.createElement("div", { className: "ml--auto" },
                    React.createElement("div", { className: classes.columnPreview }, translate('appplication-preview')),
                    React.createElement("img", { style: { width: 850, border: "1px solid #e5e1e1" }, src: "" + S3_PREFIX + selectedLanguage + ".png" })))));
    };
    var renderUserDetailsSelectPage = function () {
        return (React.createElement("div", { style: { margin: '15px 25px 0px 25px' } },
            React.createElement("h2", null, translate('select-your-details')),
            React.createElement("div", { className: "fs--15 mt--5 mb--20" }, translate('select-details-reason')),
            React.createElement("div", { className: classes.inputRow },
                React.createElement("div", null,
                    React.createElement("div", { className: classes.userDetailTitle }, translate('first-name')),
                    React.createElement("input", { className: classes.inputField, value: firstName, onChange: function (e) { return setFirstName(e.target.value); }, placeholder: String(translate('first-name-placeholder')) })),
                React.createElement("div", null,
                    React.createElement("div", { className: classes.userDetailTitle }, translate('last-name')),
                    React.createElement("input", { className: classes.inputField, value: lastName, onChange: function (e) { return setLastName(e.target.value); }, placeholder: String(translate('last-name-placeholder')) }))),
            React.createElement("div", { className: classes.inputRow },
                React.createElement("div", null,
                    React.createElement("div", { className: classes.userDetailTitle }, translate('job-title')),
                    React.createElement("input", { className: classes.inputField, value: jobTitle, onChange: function (e) { return setJobTitle(e.target.value); }, placeholder: String(translate('job-title-placeholder')) })),
                React.createElement("div", null,
                    React.createElement("div", { className: classes.userDetailTitle }, translate('company-phone')),
                    React.createElement("input", { type: "number", className: classes.inputField, value: phoneNumber, onChange: function (e) { return setPhoneNumber(e.target.value); }, placeholder: String(translate('company-phone-placeholder')) }))),
            React.createElement("div", { className: classes.inputRow, style: { marginLeft: -225 } },
                React.createElement("div", null,
                    React.createElement("div", { className: classes.userDetailTitle }, translate('country')),
                    React.createElement(Select, { value: country
                            ? { label: country, value: country }
                                ? { label: country, value: country }
                                : { label: 'None', value: 'None' }
                            : 'Select Your Country', onChange: function (e) { return handleChange(e); }, placeholder: String(translate('country-placeholder')), className: classes.inputField, styles: reactSelectStyles, menuPortalTarget: document.body, menuPosition: 'fixed', options: countries.map(function (country) {
                            return { label: country, value: country };
                        }) })))));
    };
    var renderUserProfilePicturePage = function () {
        var userName = (firstName || '') + " " + (lastName || '');
        return (React.createElement("div", { style: { margin: '15px 25px 0px 25px' } },
            React.createElement("h2", null, translate('select-profile-picture')),
            React.createElement("div", { className: "fs--15 mt--5 mb--20" }, translate('select-profile-picture-reason')),
            profilePic ? (React.createElement("div", { className: classes.profilePictureDefault },
                React.createElement("img", { src: profilePic }),
                React.createElement("div", { className: classes.clearImg, onClick: function () {
                        setProfilePicture('');
                        setSelectedFile(null);
                    } },
                    React.createElement(Icon, { style: { color: tubeColor } }, "close"),
                    React.createElement("span", null, translate('remove'))))) : (React.createElement("div", { className: classes.profilePictureDefault },
                React.createElement("span", { className: classes.profilePicText }, firstName || lastName ? getInitials(userName) : (userEmail || '').slice(0, 2).toUpperCase()))),
            React.createElement("div", { className: classes.uploadPictureButton },
                React.createElement("input", { accept: "image/*", id: "icon-button-file", onChange: function (e) {
                        if (!e.target && !e.target.files) {
                            return;
                        }
                        var url = URL.createObjectURL(e.target.files[0]);
                        setProfilePicture(url);
                        setSelectedFile(e.target.files[0]);
                    }, type: "file", style: { display: 'none' } }),
                React.createElement("label", { htmlFor: "icon-button-file" },
                    React.createElement("div", { color: "primary", className: "cursor-pointer" }, translate('upload-picture'))))));
    };
    var renderBody = function () {
        switch (currentPage) {
            case FIRST_PAGE:
                return renderLanguageSelectPage();
            case SECOND_PAGE:
                return renderUserDetailsSelectPage();
            case THIRD_PAGE:
                return renderUserProfilePicturePage();
            default:
                return React.createElement("div", null);
        }
    };
    return (React.createElement(Dialog, { fullWidth: true, 
        // maxWidth="md"
        disableBackdropClick: true, PaperProps: {
            style: {
                height: 700,
                maxWidth: 1200,
                // overflow: 'hidden',
            },
        }, open: open && !isMobile && !orgToNotShowTheDialog.includes(orgId), onClose: function () { return onClose(); } },
        renderBody(),
        React.createElement("div", { className: classNames('ds-flex navigation mt-auto', classes.navigationWrapper) },
            React.createElement("div", { className: classes.stepperIconWrapper },
                React.createElement("span", { className: classNames(classes.stepperIcons, {}), style: currentPage === FIRST_PAGE ? { background: tubeColor } : {} },
                    React.createElement(Icon, { style: { color: 'white', fontSize: 22 } }, "language")),
                React.createElement("span", { className: classes.stepperText, style: currentPage === FIRST_PAGE ? { color: tubeColor } : {} }, translate('select-language'))),
            React.createElement("div", { className: classes.stepperIconWrapper },
                React.createElement("span", { className: classes.stepperIcons, style: currentPage === SECOND_PAGE ? { background: tubeColor } : {} },
                    React.createElement(Icon, { style: { color: 'white', fontSize: 22 } }, "account_circle")),
                React.createElement("span", { className: classes.stepperText, style: currentPage === SECOND_PAGE ? { color: tubeColor } : {} }, translate('your-details'))),
            React.createElement("div", { className: classes.stepperIconWrapper },
                React.createElement("span", { className: classes.stepperIcons, style: currentPage === THIRD_PAGE ? { background: tubeColor } : {} },
                    React.createElement(Icon, { style: { color: 'white', fontSize: 22 } }, "add_a_photo")),
                React.createElement("span", { className: classes.stepperText, style: currentPage === THIRD_PAGE ? { color: tubeColor } : {} }, translate('profile-picture')))),
        React.createElement("div", { className: "ds-flex  mr-5" },
            React.createElement("div", null, currentPage !== FIRST_PAGE && (React.createElement("div", { className: classes.skipBtn, onClick: function () { return setCurrentPage(currentPage - 1); } }, translate('previous')))),
            React.createElement("div", { className: "ml--auto ds-flex" },
                React.createElement("div", { className: classNames('ml-auto', classes.skipBtn), onClick: function () { return onClose(); } }, isSaving ? (React.createElement("span", null,
                    React.createElement(Spinner, null))) : (translate('skip'))),
                currentPage !== THIRD_PAGE && (React.createElement("div", { className: classNames('ml-auto', classes.nextButtons), onClick: function () { return __awaiter(void 0, void 0, void 0, function () {
                        return __generator(this, function (_a) {
                            switch (_a.label) {
                                case 0:
                                    if (!(currentPage == FIRST_PAGE && userLanguage !== selectedLanguage)) return [3 /*break*/, 4];
                                    setSavingStatus(true);
                                    return [4 /*yield*/, updateUserPreferredLanguage()];
                                case 1:
                                    _a.sent();
                                    return [4 /*yield*/, setSavingStatus(false)];
                                case 2:
                                    _a.sent();
                                    return [4 /*yield*/, props.changeLang(selectedLanguage)];
                                case 3:
                                    _a.sent();
                                    _a.label = 4;
                                case 4:
                                    if (currentPage !== FIRST_PAGE) {
                                        onSaveProfile(currentPage === SECOND_PAGE);
                                    }
                                    setCurrentPage(currentPage + 1);
                                    return [2 /*return*/];
                            }
                        });
                    }); } }, isSaving ? (React.createElement("span", null,
                    React.createElement(Spinner, null))) : (translate('next')))),
                currentPage === THIRD_PAGE && (React.createElement("div", { className: classes.nextButtons, onClick: function () { return __awaiter(void 0, void 0, void 0, function () {
                        return __generator(this, function (_a) {
                            switch (_a.label) {
                                case 0:
                                    if (isSaving) {
                                        return [2 /*return*/];
                                    }
                                    setSavingStatus(true);
                                    return [4 /*yield*/, onSaveProfile(false)];
                                case 1:
                                    _a.sent();
                                    setSavingStatus(false);
                                    onClose();
                                    return [2 /*return*/];
                            }
                        });
                    }); } }, isSaving ? (React.createElement("span", null,
                    React.createElement(Spinner, null))) : (translate('done'))))))));
};
export default withStyles(styles, { withTheme: true })(UserInitialConfigurationDialog);



//////////////////
// WEBPACK FOOTER
// ./src/components/layouts/Main/UserInitialConfigurationDialog.tsx
// module id = 2044
// module chunks = 81